import { useApp } from "@/store/AppStore";
import { useAsesor } from "@/hooks/useAsesor";
import SectionTitle from "@/components/base/SectionTitle";
import CatalogVisual from "@/components/feature/CatalogVisual";

// Catálogo Visual del asesor: ve todo el portafolio Amway con su precio público,
// su PV y sus unidades disponibles. Es de solo lectura: aquí no se edita nada.
const AsesorCatalogPage = () => {
  const { data } = useApp();
  const { advisorId } = useAsesor();

  return (
    <div className="pb-24">
      <SectionTitle
        text="Catálogo Amway"
        subtitle="Explora todo el portafolio con foto, precio público, PV y tus unidades disponibles. Es una vista de consulta: no modifica nada."
      />
      <CatalogVisual
        products={data.products}
        inventory={data.inventory}
        advisorId={advisorId}
      />
    </div>
  );
};

export default AsesorCatalogPage;